import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { ToolbarItemProps } from "./ToolbarItems";

interface DefaultEditButtonProps<T> {
  onClick: (selectedItem: T) => void;
  disabled?: (selectedItem: T) => boolean;
  roles?: string[];
}

export const defaultEditButton = <T>({
  onClick,
  text = "Edit",
  icon = faPencil,
  disabled = (selectedItem: T) => !selectedItem,
  roles = [],
}: DefaultEditButtonProps<T> & Partial<ToolbarItemProps>) => ({
  text,
  icon,
  onClick,
  disabled,
  roles,
});
